/** Decode HTML entities for plain-text UI (handles numeric/named refs; repeat for double-encoded API values). */
export const decodeHTML = (text, maxPasses = 4) => {
  if (text == null || typeof text !== "string") return text;
  if (typeof document === "undefined") return text;
  const textArea = document.createElement("textarea");
  let cur = text;
  for (let i = 0; i < maxPasses; i++) {
    textArea.innerHTML = cur;
    const next = textArea.value;
    if (next === cur) break;
    cur = next;
  }
  return cur;
};

/** Strip HTML tags and decode entities from an API string for plain-text UI (e.g. a card teaser). */
export const stripHtml = (html) => {
  if (typeof html !== "string") return "";
  if (typeof document === "undefined") {
    return html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  }
  const tmp = document.createElement("div");
  tmp.innerHTML = html;
  return (tmp.textContent || tmp.innerText || "").replace(/\s+/g, " ").trim();
};

export const miraSiHayCirilicos = (texto) => {
  const cyrillicPattern = /[\u0400-\u04FF]/;
  return cyrillicPattern.test(texto);
};

export const isEmpty = (value) => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string") return value.trim() === "";
  if (typeof value === "number") return false;
  return !value;
};

/**
 * Elimina cualquier texto entre paréntesis (y los espacios que lo rodean) de
 * una cadena, dejando el resto limpio. Se usa p.ej. para el motivo de
 * devolución: el modal decora el BEZEI con coletillas como
 * "(Especificar en observaciones)" que no deben persistirse ni imprimirse.
 */
export const stripParentheticals = (text) =>
  (text == null ? "" : String(text)).replace(/\s*\([^)]*\)/g, "").trim();
